module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"removeConfirm":"Are you sure you want to delete this relation?","updateSuccess":"Main contact changed successfully"},"et":{"removeConfirm":"Are you sure you want to delete this relation?","updateSuccess":"Main contact changed successfully"},"ru":{"removeConfirm":"Are you sure you want to delete this relation?","updateSuccess":"Main contact changed successfully"}}')
  delete Component.options._Ctor
}
